import { api } from "@/axios";
//import responseHandler from "@/responseHandler.js";

const state = {
  books: [],
  article: {},
};

const getters = {
  getBooks: (state) => state.books,
};

const actions = {
  async fetchBooks({ commit }) {
    try {
      const resp = await api.get("/books");
      if (resp.status == 200) {
        const books = resp.data.data;
        commit("setBooks", books);
      }
    } catch (error) {
      console.log("error", error);
      return false;
    }
  },
};

const mutations = {
  setBooks(state, books) {
    state.books = books;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
